import Documents from "./Documents";
import { useGetDocumentQuery } from "types/generated/operations";
import Loader from "uicomponents/Loader";
import Error from "uicomponents/Error";
import { getProspectUuid } from "utils/idHelpers";

interface IDocumentModelProps {
  setNextStep: () => void;
  setPreviousStep: () => void;
}

const DocumentsModel = ({ ...props }: IDocumentModelProps) => {
  const { data, error, loading } = useGetDocumentQuery({
    variables: { uuid: getProspectUuid() },
    fetchPolicy: "no-cache",
  });
  if (loading) {
    return <Loader />;
  }
  if (error) {
    return <Error />;
  }
  return (
    <Documents
      data={data?.prospect}
      setNextStep={props.setNextStep}
      setPreviousStep={props.setPreviousStep}
    />
  );
};
export default DocumentsModel;
